import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  aDateStart() {
    return faker.date.past();
  },

  headline() {
    return faker.lorem.sentence();
  },

  text() {
    return faker.lorem.paragraphs();
  },

  afterCreate(article, server) {
    let numArtists = faker.datatype.number({
      min: 1,
      max: 3,
    });

    article.update({
      artists: server.createList('artist', numArtists),
    });
  },
});
